import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import store from './Redux/store'
import { Provider } from 'react-redux'
declare let window: any

// Don't auto render the react project while embedding inside of Unicorn
// const root = ReactDOM.createRoot(document.getElementById('root')!);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// loadReactComponent is a global function for loading react pages
window.loadReactComponent = (rootId: string, componentOptions: object = {}) => {
    const root = ReactDOM.createRoot(document.getElementById(rootId)!)
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                {' '}
                {/* Wrap App with Provider */}
                <App options={componentOptions} />
            </Provider>
        </React.StrictMode>
    )
}


// disable logging 
if (process.env.NODE_ENV == 'production'){
    console.log = () => {};
    console.group = () => {};
}

